"use client";

import React from "react";
import Link from "next/link";
import { AiOutlineClockCircle } from "react-icons/ai";

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("vi-VN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const NewsItem = ({ item, type = "vertical" }) => {
  if (type === "horizontal") {
    return (
      <Link href={`/tin-tuc/${item.id}`}>
        <div className="flex gap-4 group cursor-pointer">
          <div className="w-[180px] h-[120px] flex-shrink-0 overflow-hidden">
            <img
              src={item.thumbnail}
              alt={item.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <div className="flex items-center gap-2 text-[#999] text-xs mb-2">
              <AiOutlineClockCircle color="#06B6D4" />
              <span className="text-[#06B6D4]">
                {formatDate(item.createdAt)}
              </span>
            </div>
            <h3 className="text-sm font-bold text-[#333] mb-2 line-clamp-2 group-hover:text-[#E5C383] transition-colors">
              {item.title}
            </h3>
            <p className="text-xs text-[#666] line-clamp-2">
              {item.description}
            </p>
          </div>
        </div>
      </Link>
    );
  }

  // Vertical (Default)
  return (
    <Link href={`/tin-tuc/${item.id}`}>
      <div className="group cursor-pointer">
        <div className="w-full aspect-[3/2] overflow-hidden mb-4">
          <img
            src={item.thumbnail}
            alt={item.title}
            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        <div className="flex items-center gap-2 text-[#999] text-sm mb-3">
          <AiOutlineClockCircle color="#06B6D4" />
          <span className="text-[#06B6D4]"> {formatDate(item.createdAt)}</span>
        </div>
        <h3 className="text-lg font-bold text-[#333] mb-3 line-clamp-2 group-hover:text-[#E5C383] transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-[#666] line-clamp-3 leading-relaxed">
          {item.description}
        </p>
      </div>
    </Link>
  );
};

export default NewsItem;
